/*
 * Title: Signedout/RedeemTab.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Aside, MobileHead,Navigation, RedeemContent from components.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import KnightsCard from "@components/Profile/KnightsCard";
import MobileHead from "@components/Profile/MobileHead";
import Navigation from "@components/Profile/Navigation";
import RedeemContent from "@components/Profile/RedeemContent";
import React from "react";
import "./index.css";

type Props = {};
type MyState = {};
class RedeemTab extends React.Component<Props, MyState> {
  state: MyState = {};

  render() {
    return (
      <div className="relative h-screen overflow-hidden lg:overflow-visible lg:flex lg:items-center lg:justify-center">
        {/* Mobile Head imported from components  */}
        <MobileHead />

        <div className="container mx-auto">
          <div className="lg:grid lg:grid-cols-3 lg:gap-4">
            {/* desktop aside end */}
            <div className="hidden 2xl:pr-20 lg:block">
              {/* desktop points stats start*/}
              <KnightsCard />
              {/* desktop points stats end*/}
            </div>

            <div className="lg:col-span-2">
              {/* Tabs  */}
              <div className="w-full">
                {/* tabs page navigation  */}
                <Navigation />
              </div>
              {/* tabs  */}
              <RedeemContent />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RedeemTab;
